import { type NgTraditional } from './ngTraditional';

export enum ConflictType {
	Property = 'property',
	ChildrenReorder = 'reorder',
	ItemMove = 'item-move',
	DeletedModified = 'deleted-modified',
	ModifiedDeleted = 'modified-deleted'
}
interface ConflictBase {
	conflictId: string;
	conflictType: ConflictType;
	entityType: NgTraditional;
	entityId: string;
	attribute: string;
}

export interface Conflict extends ConflictBase {
	initial: string;
	current: string;
	incoming: string;
}

export interface ReorderConflict extends ConflictBase {
	initial: string[];
	current: string[];
	incoming: string[];
}
